<div class="grid">
	<div class="col-12">
		<div class="card">
			<div class="formgroup">
				<div class="p-fluid p-formgrid grid">
					<div class="field col-12 md:col-2">
						<button pButton pRipple routerLink="/rfarias/administradora/inserir" label="Novo"
							icon="pi pi-plus" class="p-button-info mr-2 mb-2"></button>
					</div>
				</div>
			</div>
			<p-divider></p-divider>
			<h4>Franquias</h4>
			<div class="flex justify-content-center" *ngIf="loadingAdminitradoras">
				<p-progressSpinner></p-progressSpinner>
			</div>
			<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
				<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
			</div>
			<p-table #dt1 [value]="administradoras" dataKey="id" [rows]="10" [loading]="loading" [rowHover]="true"
				styleClass="p-datatable-gridlines" [paginator]="true"
				[globalFilterFields]="['nomeFantasia', 'cidade', 'uf']" responsiveLayout="scroll"
				styleClass=" p-datatable-sm" *ngIf="!loadingAdminitradoras">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<div></div>
						<div>
							<span class="p-input-icon-left">
								<i class="pi pi-search"></i>
								<input pInputText type="text" #filter (input)="buscar(dt1, $event)" placeholder="Buscar"
									class="w-full" />
							</span>
							<span class="ml-2">
								<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
									pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
							</span>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>

						<th pSortableColumn="nomeFantasia">
							Nome
							<p-sortIcon field="nomeFantasia">
							</p-sortIcon>
						</th>
						<th pSortableColumn="cidade">
							Cidade
							<p-sortIcon field="cidade">
							</p-sortIcon>
						</th>
						<th pSortableColumn="uf">
							UF
							<p-sortIcon field="uf">
							</p-sortIcon>
						</th>
						<th>
							<div>
								Ações
							</div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
						<td>
							{{item.nomeFantasia}}
						</td>
						<td>
							{{item.cidade}}
						</td>
						<td>
							{{item.uf}}
						</td>
						<td>
							<button pButton pRipple pTooltip="Detalhar" icon="pi pi-eye" (click)="detalhar(item.id)"
								class="p-button-info mr-2 mb-2"></button>
							<button pButton pRipple pTooltip="Editar" (click)="editar(item.id)" icon="pi pi-pencil"
								class="p-button-success mr-2 mb-2"></button>

						</td>

					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando clientes. Por favor aguarde.</td>
					</tr>
				</ng-template>
			</p-table>
			<p-confirmDialog [style]="{width: '50vw'}">
			</p-confirmDialog>
		</div>
	</div>
</div>